import React, {useState} from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import useOnMount from 'ui-library/hooks/useOnMount';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';

import {
  approveRollout,
  InstrumentGatewayUpgrade,
  listPendingUpgradesForGateway,
} from './InstrumentGatewayDAO';

interface UpgradeGatewayModalProps {
  gatewayId: string;
  onRequestClose: () => void;
}

function UpgradeGatewayModal(props: UpgradeGatewayModalProps): JSX.Element {
  const [pendingUpgrades, setPendingUpgrades] = useState([] as Array<InstrumentGatewayUpgrade>);
  const [isLoading, setIsLoading] = useState(true);
  const refetch = (): void => {
    setIsLoading(true);
    listPendingUpgradesForGateway(props.gatewayId).then(({pendingUpgrades}) => {
      setPendingUpgrades(pendingUpgrades);
      setIsLoading(false);
    });
  };
  useOnMount(refetch);
  return (
    <Modal
      buttons={[
        {
          style: ButtonStyle.SECONDARY,
          cancel: true,
          text: 'Close',
        },
      ]}
      onRequestClose={props.onRequestClose}
      title="Upgrade adapters installed on gateway"
    >
      {isLoading ? (
        <CenteredHorizontalThrobber />
      ) : pendingUpgrades.length === 0 ? (
        'No available upgrades'
      ) : (
        pendingUpgrades.map((pendingUpgrade) => (
          <Button
            key={pendingUpgrade.id}
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={async () => {
              await approveRollout(props.gatewayId, pendingUpgrade.id);
              refetch();
            }}
            text={`Upgrade ${pendingUpgrade.adapter.displayName} to ${pendingUpgrade.version}`}
            icon="paperclip"
          />
        ))
      )}
    </Modal>
  );
}

export default UpgradeGatewayModal;
